import React from 'react';
import { ToolUseProcessSupervisionStepResponse } from '@scale/shared/types/chat';
import { Tag, Typography } from '@scale/scaleui';
import ProcessSupervisionChunkStep from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions/ProcessSupervision/ToolUseProcessSupervision/ProcessSupervisionChunkStep';
import { DEFAULT_TOOL_USE_PROCESS_SUPERVISION_RATING_OPTIONS } from '@scale/shared/types/chat/toolUseProcessSupervision';

type Props = {
  isRunToolOnly: boolean;
  actionPlan: Partial<ToolUseProcessSupervisionStepResponse['context']['actionPlan']>;
  setActionPlan: (
    actionPlan: Partial<ToolUseProcessSupervisionStepResponse['context']['actionPlan']>,
  ) => void;
};

const ToolUseProcessSupervisionActionPlan: React.FC<Props> = ({
  actionPlan,
  setActionPlan,
  isRunToolOnly = false,
}) => {
  if (!actionPlan) {
    return null;
  }
  return (
    <div>
      <Typography.Subtitle3 className="flex flex-col items-start gap-2">
        <Tag className="mb-4" size="lg" variant="primary">
          ACTION PLAN
        </Tag>
      </Typography.Subtitle3>
      <ProcessSupervisionChunkStep
        chunk={actionPlan}
        ratingOptions={DEFAULT_TOOL_USE_PROCESS_SUPERVISION_RATING_OPTIONS}
        setChunk={setActionPlan}
        disabled={isRunToolOnly}
      />
    </div>
  );
};

export default ToolUseProcessSupervisionActionPlan;
